import { atom } from 'recoil';

var notificationsAtom = atom({
    key: "Component-NotificationsAtom",
    "default": []
});

export { notificationsAtom };
//# sourceMappingURL=atoms.js.map
